/* ========================================
   Custom Section — Double Image
   Two images displayed side by side
   ======================================== */

window.sectionRenderers = window.sectionRenderers || {};

window.sectionRenderers.doubleImage = function(data) {
  if (!data.imageUrlLeft && !data.imageUrlRight) return '';
  return '<div class="cs-double-image">' +
    '<div class="cs-double-image__item">' +
      (data.imageUrlLeft ? '<img src="' + escapeHtml(data.imageUrlLeft) + '" alt="" loading="lazy">' : '') +
    '</div>' +
    '<div class="cs-double-image__item">' +
      (data.imageUrlRight ? '<img src="' + escapeHtml(data.imageUrlRight) + '" alt="" loading="lazy">' : '') +
    '</div>' +
  '</div>';
};
